const requireContext = require.context('./', true, /.*\.js$/)
requireContext.keys().forEach(file => {
    requireContext(file)
})
